import { ref, reactive, computed, onMounted, watch } from 'vue'
import { defineStore } from 'pinia'

import { useCategory } from '@store/category'
import { useService } from '@store/service'
import { useStaff } from '@store/staff'
import { useSettings } from '@store/settings'

import { useRoute, useRouter } from 'vue-router'

import { isInteger, validationCheck } from '@utils'

export const useServiceItem = defineStore('serviceItem', () => {
    const $category = useCategory()
    const $service = useService()
    const $staff = useStaff()
    const $settings = useSettings()
    const route = useRoute()
    const router = useRouter()


    const state = reactive({
        loading: true,
    })

    const service = ref({
        meta: {},
        staffs: [],
    })

    const resetService = () => {
        service.value = {
            meta: {},
            staffs: [],
        }
    }

    const serviceId = computed(() => {
        return route.params.serviceId || route.query.serviceId || service.value.service_id
    })
    const isNew = computed(() => {
        console.log(service.value, serviceId.value)
        return !serviceId.value
    })

    const isServiceChanged = ref(false)

    watch(service, (newVal, oldVal) => {
        isServiceChanged.value = true
    }, { deep: true })

    const mountServiceItem = async () => {
        await $staff.fetchData()
        $service.fetchData()
        $category.fetchCategories()

        Log('IS New', isNew.value)

        if (isNew.value) {
            // Sync category id.
            service.value.category_id = Number(route.query.categoryId)

            const getRandomColor = () => {
                const keys = Object.keys(prebook_admin.options.color_sets)
                return keys[Math.floor(Math.random() * keys.length)]
            }

            console.log($settings.getSettings.service)
            service.value.meta = {
                color: getRandomColor(),
                duration: $settings.getSettings.service?.default_duration || '0',
                duration_unit: $settings.getSettings.service?.default_duration_unit || 'minute',
                pre_buffer_unit: 'minutes',
                post_buffer_unit: 'minutes',
                deposit_type: 'fixed',
                booking_type: ['Onsite'],
                price: 0,
                thumbnail_image_url: '',
                price_type: 'fixed',
                is_private: false,
            }

            isServiceChanged.value = false
            state.loading = false
            return
        }

        // Loading.
        state.loading = true

        // Fetch Service.
        service.value = await $service.serviceModel().get(serviceId.value)
        Log('Service', service.value)

        service.value.meta.is_private = Boolean(service.value.meta.is_private)

        // Not loading.
        state.loading = false
        isServiceChanged.value = false
    }

    const submit = async (type, onboarding = false) => {
        if (!service.value.category_id) {
            const UncategorisedCategory = $service.getCategories.find(cat => cat.name == 'Uncategorised')
            service.value.category_id = UncategorisedCategory.category_id
        }

        // if (!$settings.addons.staffs) {
        //     let findProvider = $staff.getStaffs.find(s => s.meta.timezone)// change meta.timezone to meta.provider

        //     if (findProvider) {
        //         service.value.staffs.push(findProvider.staff_id)
        //     }
        // }

        console.log('serviceItem service', service.value)
        // validation
        let { errors } = type !== 'draft' ? validationCheck([
            {
                condition: !service.value.name,
                message: `${$settings.labels.service?.singular} name is required`
            },
            {
                condition: !service.value.category_id,
                message: `${$settings.labels.service?.singular} category is required`
            },
            {
                condition: $settings.addons.staffs && service.value.staffs.length === 0,
                message: `${$settings.labels.service?.singular} must have at least one ${$settings.labels.staff?.singular}`
            },
            // {
            //     condition: !isIPnteger(service.value.meta.duration),
            //     message: 'Service duration must be an integer number (whole number)'
            // },
            {
                condition: service.value.meta.duration <= 0,
                message: `${$settings.labels.service?.singular} duration must be greater than 0`
            },
            {
                condition: service.value.meta.price_type == 'fixed' && !service.value.meta.price,
                message: `${$settings.labels.service?.singular} price is required for Fixed price type`
            },
            {
                condition: service.value.meta.price && service.value.meta.price <= -1,
                message: `${$settings.labels.service?.singular} price must be equal or greater than 0`
            },
            {
                condition: !service.value.meta.price_type,
                message: `${$settings.labels.service?.singular} price type is required`
            }
        ]) : false


        if (errors) return state.saving = false

        let isArchived = service.value.status == 'archive'

        service.value.meta.booking_type = "Onsite"
        service.value.status = type
        // after validation submit form
        state.saving = true

        // get service max priority
        if (isNew.value == true) {
            let servicesUnderCategory = $service.getServices.filter(s => s.category_id == service.value.category_id) // get all services under selected category
            let maxPriority = servicesUnderCategory.length ? Math.max(...servicesUnderCategory.map(ser => ser.meta.order)) : 0
            service.value.meta.order = maxPriority + 1
        }

        const response = await $service.updateService(service.value, false)

        if (response.success == true && isNew.value == true) {

            // router.push({
            //     name: 'service.edit',
            //     params: {
            //         serviceId: response.data.service_id,
            //     },
            //     query: route.query
            // })

            // back to list page [issue #82]
            router.push({ name: 'service.list' })

            service.value.service_id = response.data.service_id
        }
        state.saving = false

        if (response.success) {
            if (isArchived)
                Toast.success(`${$settings.labels.service?.singular} restored and published successfully`)
            else if (type === 'draft')
                Toast.success(`${$settings.labels.service?.singular} draft saved successfully`)
            else if (type === 'archive')
                Toast.success(`${$settings.labels.service?.singular} archived successfully`)
            else if (isNew.value) {
                Toast.success(`${$settings.labels.service?.singular} added successfully`)
                // back to list page [issue #82]
                router.push({ name: 'service.list' })
            }
            else {
                Toast.success(`${$settings.labels.service?.singular} details updated successfully`)
                // back to list page [issue #82]
                router.push({ name: 'service.list' })
            }


        }

        if (onboarding) {
            resetService()
            router.push({ name: 'dashboard' })
        }
    }

    // watch(() => service, () => {
    //     console.log('service item', service.value)
    // }, { deep: true })

    return {
        service, isNew, state, resetService, mountServiceItem, submit, isServiceChanged
    }
})